(() => {
  const initializeAnnouncement = () => {
    const headerGroup = document.querySelector('#header-group');
    if (!headerGroup || headerGroup.querySelector('.qualor-announcement-v2')) return;

    const announcement = document.createElement('aside');
    announcement.className = 'qualor-announcement-v2';
    announcement.setAttribute('aria-label', 'הודעות חשובות');

    const rail = document.createElement('div');
    rail.className = 'qualor-announcement-v2__rail';
    const message = 'משלוח חינם לכל הארץ 30 ימי ניסיון בראש שקט 50% הנחה לזמן מוגבל';

    for (let groupIndex = 0; groupIndex < 2; groupIndex += 1) {
      const group = document.createElement('div');
      group.className = 'qualor-announcement-v2__group';
      if (groupIndex === 1) group.setAttribute('aria-hidden', 'true');

      for (let repeatIndex = 0; repeatIndex < 3; repeatIndex += 1) {
        const item = document.createElement('span');
        item.textContent = message;
        group.appendChild(item);
      }

      rail.appendChild(group);
    }

    announcement.appendChild(rail);
    headerGroup.prepend(announcement);
  };

  const initializeBenefitTouchPause = (scope = document) => {
    const tracks = scope.querySelectorAll('.qualor-benefit-track:not([data-qualor-touch-ready])');

    tracks.forEach((track) => {
      track.dataset.qualorTouchReady = 'true';
      const rail = track.querySelector('.qualor-benefit-rail');
      let marqueeAnimation;
      let startX = 0;
      let startY = 0;
      let lastX = 0;
      let isHorizontalDrag = false;

      track.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1 || !rail) return;

          const touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          lastX = touch.clientX;
          isHorizontalDrag = false;
          track.classList.add('qualor-touch-paused');

          marqueeAnimation = rail
            .getAnimations()
            .find((animation) => animation.animationName === 'qualor-marquee-v11');
          marqueeAnimation?.pause();
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        (event) => {
          if (event.touches.length !== 1 || !marqueeAnimation || !rail) return;

          const touch = event.touches[0];
          const totalX = touch.clientX - startX;
          const totalY = touch.clientY - startY;

          if (!isHorizontalDrag) {
            if (Math.abs(totalX) < 7) return;
            if (Math.abs(totalX) <= Math.abs(totalY)) return;
            isHorizontalDrag = true;
          }

          event.preventDefault();

          const deltaX = touch.clientX - lastX;
          const duration = Number(marqueeAnimation.effect?.getTiming().duration);
          const loopDistance = rail.scrollWidth / 2;

          if (duration > 0 && loopDistance > 0) {
            const currentTime = Number(marqueeAnimation.currentTime) || 0;
            let nextTime = currentTime + (deltaX / loopDistance) * duration;
            nextTime = ((nextTime % duration) + duration) % duration;
            marqueeAnimation.currentTime = nextTime;
          }

          lastX = touch.clientX;
        },
        { passive: false }
      );

      const resume = () => {
        track.classList.remove('qualor-touch-paused');
        marqueeAnimation?.play();
        marqueeAnimation = undefined;
        isHorizontalDrag = false;
      };

      track.addEventListener('touchend', resume, { passive: true });
      track.addEventListener('touchcancel', resume, { passive: true });
    });
  };

  const revealSections = () => {
    const sections = document.querySelectorAll('.qualor-home:not([data-qualor-reveal])');
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('qualor-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    sections.forEach((section, index) => {
      section.dataset.qualorReveal = '';
      if (index === 0 || section.getBoundingClientRect().top < window.innerHeight * 0.9) {
        section.classList.add('qualor-is-visible');
      } else {
        observer.observe(section);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAnnouncement();
      revealSections();
      initializeBenefitTouchPause();
    });
  } else {
    initializeAnnouncement();
    revealSections();
    initializeBenefitTouchPause();
  }
  document.addEventListener('shopify:section:load', (event) => {
    initializeAnnouncement();
    revealSections();
    initializeBenefitTouchPause(event.target);
  });
})();
